// extracted by mini-css-extract-plugin
module.exports = {"container":"_2vhw0BfP52o5BwyKfDib0p"};